<template>
    <div class="input-container" :class="label ? 'input-container-with-label' : ''">
        <div class="title-style-container">
            <form-label-title v-if="label" :label="label" :is-required="isRequired" :is-margin="!isStyle" />

            <slot />    
        </div>
        
        <el-input 
            v-model="value"
            :placeholder="placeholder"
            :disabled="disabled"
            :clearable="clearable"
            :show-password="showPassword"
            :suffix-icon="suffixIcon"
            :prefix-icon="prefixIcon"
            :type="type"
            :rows="rows"
            :autosize="autosize"
            :size="size"
            :minlength="minLength"
            :maxlength="maxLength"
            :show-word-limit="showWordLimit"
            :min="min"
            :max="max"
            :step="step"
            :required="isRequired"
            @change="handleChange($event)"
            @keypress.native="handleKeyPress($event)"
        />
    </div>
</template>

<script>
import FormLabelTitle from "./FormLabelTitle";

export default {
    components: {
        "form-label-title": FormLabelTitle,
    },
    props: {
        inputValue: {
            type: String | Number
        },
        label: {
            type: String
        },
        placeholder: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showPassword: {
            type: Boolean,
            default: false
        },
        suffixIcon: {
            type: String
        },
        prefixIcon: {
            type: String
        },
        type: {
            type: String
        },
        rows: {
            type: String | Number,
        },
        autosize: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: "small"
        },
        minLength: {
            type: String | Number,
        },
        maxLength: {
            type: String | Number,
        },
        showWordLimit: {
            type: Boolean,
            default: false
        },
        min: {
            type: String | Number,
        },
        max: {
            type: String | Number,
        },
        step: {
            type: String | Number,
        },
        isRequired: {
            type: Boolean
        },
        isStyle: {
            type: Boolean,
            default: false
        },
        isNumber: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        value: {
            set(val) {
                this.$emit("update:inputValue", val);
            },
            get() {
                return this.inputValue;
            }
        }
    },
    methods: {
        handleChange(value) {
            console.log("handle change", value);
            this.$emit("handleChange", value);
        },
        handleKeyPress(evt) {
            if (this.isNumber == true) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            }
        }
    },
};
</script>

<style lang="css" scoped>
.title-style-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
<style>
.input-container .el-textarea {
    margin-top: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/Form/FormInput.vue